export const selectTags = state => state.tags.tags;
export const selectSelectedTag = state => state.tags.selectedTag;
export const getSelectedUsers = state => state.tags.selectedUsers;
export const selectAddTagDialog = state => state.tags.addTagDialog;
export const getTagsSuccess = state => state.tags.tagsSuccess;
export const getUsersTagsDialog = state => state.tags.removeUsersTagsOpen;



// WEBPACK FOOTER //
// ./src/redux/tags/selectors.js